import * as _ from 'underscore'
import { DataProvider } from "../helpers"

import { Enums } from "../models/common"
import { OpActionType, OpActionData } from "../models/core"
import { ColumnInfo, OpActionResult } from "../models/custom"
import { OpAction } from "../models/core/op-action"
import { DataValue } from "../models/local"


export class DataProviderAction {

    // Ctor

    constructor(private dataProvider: DataProvider) { }

    // Ctor End


    // Public Methods

    public getActionFilter = (columns: ColumnInfo[], pageNbr: number, pageSize: number, customWhereClause: string) => {
        return this.dataProvider.sendFilterRequestWithSession<OpAction>(columns, pageNbr, pageSize, customWhereClause, Enums.ReferenceType.IdAction, 'OpxActionFilter', 'OpxActionFilterResult')
    }

    public getActionParameters = (idActionType: number, referenceType: Enums.ReferenceType, referenceValue: any): JQueryPromise<OpActionData[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetActionParameters', { IdActionType: idActionType, ReferenceType: referenceType, ReferenceValue: referenceValue }, 'OpxGetActionParametersResult')
            .then((response: any) => {
                return DataProvider.convertArrayResult<OpActionData>(response, OpActionData)
            })
    }

    public checkActionStatus = (ids: number[]): JQueryPromise<OpAction[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxCheckActionStatus', { IdAction: ids }, 'OpxCheckActionStatusResult')
            .then((response: any) => {
                return DataProvider.convertArrayResult<OpAction>(response, OpAction)
            })
    }

    public getCorrespondingActionType = (referenceValue: number[], referenceType: Enums.ReferenceType): JQueryPromise<OpActionType[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxGetCorrespondingActionType', { ReferenceValue: referenceValue, ReferenceType: referenceType }, 'OpxGetCorrespondingActionTypeResult')
            .then((response: any) => {
                return DataProvider.convertArrayResult<OpActionType>(response, OpActionType)
            })
    }

    public sendAction = (actionId: number, referenceValue: number[], referenceType: Enums.ReferenceType, dataValues: DataValue[]): JQueryPromise<OpActionResult[]> => {
        return this.dataProvider
            .sendRequestWithSession('OpxSendAction', { IdActionType: actionId, ReferenceValue: referenceValue, ReferenceType: referenceType, DataValues: _.size(dataValues) > 0 ? dataValues.map((data: DataValue) => data.toJSON()) : null }, 'OpxSendActionResult')
            .then((response: any[]) => {
                return DataProvider.convertArrayResult<OpActionResult>(response, OpActionResult)
            })
    }

    // Public Methods End
}